import { useMemo } from 'react';
import { ProjectId } from 'api/models';
import { StatusGroup } from 'api/tasks';
import { useProjectDetail } from './use-project-detail';
import { useSprints } from './use-sprints';
export const getTaskCounter = (fields = [])=>{
    var _fields_filter, _fields_filter1, _fields_filter2, _fields_filter3;
    return {
        completed: ((_fields_filter = fields.filter((subTaskStatus)=>{
            var _subTaskStatus_metaFieldValue;
            return ((_subTaskStatus_metaFieldValue = subTaskStatus.metaFieldValue) === null || _subTaskStatus_metaFieldValue === void 0 ? void 0 : _subTaskStatus_metaFieldValue.group) === StatusGroup.Completed;
        })) === null || _fields_filter === void 0 ? void 0 : _fields_filter.length) || 0,
        inProgress: ((_fields_filter1 = fields.filter((subTaskStatus)=>{
            var _subTaskStatus_metaFieldValue;
            return ((_subTaskStatus_metaFieldValue = subTaskStatus.metaFieldValue) === null || _subTaskStatus_metaFieldValue === void 0 ? void 0 : _subTaskStatus_metaFieldValue.group) === StatusGroup.InProgress;
        })) === null || _fields_filter1 === void 0 ? void 0 : _fields_filter1.length) || 0,
        todo: ((_fields_filter2 = fields.filter((subTaskStatus)=>{
            var _subTaskStatus_metaFieldValue;
            return ((_subTaskStatus_metaFieldValue = subTaskStatus.metaFieldValue) === null || _subTaskStatus_metaFieldValue === void 0 ? void 0 : _subTaskStatus_metaFieldValue.group) === StatusGroup.Todo;
        })) === null || _fields_filter2 === void 0 ? void 0 : _fields_filter2.length) || 0,
        blocked: ((_fields_filter3 = fields.filter((subTaskStatus)=>{
            var _subTaskStatus_metaFieldValue;
            return ((_subTaskStatus_metaFieldValue = subTaskStatus.metaFieldValue) === null || _subTaskStatus_metaFieldValue === void 0 ? void 0 : _subTaskStatus_metaFieldValue.group) === StatusGroup.Blocked;
        })) === null || _fields_filter3 === void 0 ? void 0 : _fields_filter3.length) || 0
    };
};
export const useProjectPhaseFromStore = (projectId, phaseId)=>{
    const { data } = useProjectDetail(ProjectId(projectId));
    return useMemo(()=>data ? data.projectPhases.find(({ projectPhaseId })=>phaseId === projectPhaseId) : undefined, [
        data,
        phaseId
    ]);
};
export const useProjectPhaseStore = (matchingPhaseTasks)=>{
    const firstLevelTasks = useMemo(()=>matchingPhaseTasks.filter((task)=>{
            var _task_parentTaskObject;
            return ((_task_parentTaskObject = task.parentTaskObject) === null || _task_parentTaskObject === void 0 ? void 0 : _task_parentTaskObject.taskId) == null;
        }), [
        matchingPhaseTasks
    ]);
    const firstLevelTasksFields = useMemo(()=>firstLevelTasks.reduce((result, item)=>result.concat(item.fields), []), [
        firstLevelTasks
    ]);
    const subTasksFields = useMemo(()=>matchingPhaseTasks.filter((task)=>{
            var _task_parentTaskObject;
            return ((_task_parentTaskObject = task.parentTaskObject) === null || _task_parentTaskObject === void 0 ? void 0 : _task_parentTaskObject.taskId) != null;
        }).reduce((result, item)=>result.concat(item.fields), []), [
        matchingPhaseTasks
    ]);
    const firstLevelTaskCounter = useMemo(()=>getTaskCounter(firstLevelTasksFields), [
        firstLevelTasksFields
    ]);
    const subTaskCounter = useMemo(()=>getTaskCounter(subTasksFields), [
        subTasksFields
    ]);
    return useMemo(()=>({
            tasks: firstLevelTasks,
            allTasks: matchingPhaseTasks,
            completedTaskCount: firstLevelTaskCounter.completed + subTaskCounter.completed,
            inprogressTaskCount: firstLevelTaskCounter.inProgress + subTaskCounter.inProgress,
            firstLevelTaskCounter,
            subTaskCounter
        }), [
        firstLevelTaskCounter,
        firstLevelTasks,
        matchingPhaseTasks,
        subTaskCounter
    ]);
};
export const useProjectPhaseByProjectId = (projectId)=>{
    const { data } = useProjectDetail(ProjectId(projectId));
    return useMemo(()=>{
        return data ? data.projectPhases : [];
    }, [
        data
    ]);
};
export const useSprintsByProjectId = (projectId, options)=>{
    const { data } = useSprints(ProjectId(projectId), options);
    return data;
};
